import React from "react";

import { cn } from "@/app/handlers/cn.utils.js";
import { wrapLinksAndEmails } from "@/app/handlers/valueTransformation.js";

import { ApplicationDetails, isJobExpired, JobDetails } from "../utils/helpers";

interface ApplicationProcessProps {
	jobDetails: JobDetails;
	applicationDetails: ApplicationDetails;
	scrollToEmail: boolean;
	applicationRef: React.RefObject<HTMLDivElement>;
	onApply: (link: string | null) => void;
}

export function ApplicationProcess({
	jobDetails,
	applicationDetails,
	scrollToEmail,
	applicationRef,
	onApply,
}: ApplicationProcessProps) {
	if (!jobDetails?.applicationProcess || jobDetails?.applicationProcess === "" || isJobExpired(jobDetails.closeAt)) {
		return null;
	}

	return (
		<div
			className={cn("mb-8", {
				"bg-primary-100 p-2 px-3 rounded": scrollToEmail,
			})}
			id="applicationProcess"
			ref={applicationRef}
		>
			<h2 className="text-base font-semibold mb-2 font-inter">Application Process</h2>
			<div
				className="text-gray-700 font-inter content-wrapper"
				dangerouslySetInnerHTML={{
					__html: wrapLinksAndEmails(jobDetails?.applicationProcess),
				}}
			/>
			{applicationDetails.applicationType === "URL" && (
				<button
					className="inline-flex mt-4 items-center justify-center bg-primary-700 text-white px-4 h-9 rounded-lg hover:bg-primary-800 transition-colors duration-300 text-sm font-inter w-[90px] group relative overflow-hidden"
					onClick={() => onApply(applicationDetails.link)}
				>
					<span className="mr-1 group-hover:mr-3 transition-all duration-300">Apply</span>
					<span className="absolute right-4 opacity-0 transition-all duration-300 transform translate-x-2 group-hover:opacity-100 group-hover:translate-x-0">
						›
					</span>
				</button>
			)}
		</div>
	);
}
